module.exports = __webpack_public_path__ + "img/1224156196.2ee30deb.jpg";